import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getUserAll,
  resetPassword,
  softDeleteUser,
} from "../../Services/UserService";
import { InputSwitch } from "primereact/inputswitch";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { uuid } from "../../Utils/Utils";
import EditButton from "../../Components/Button/EditButton";
import CustomButton from "../../Components/Button/CustomButton";
import { useSelector } from "react-redux";
import { getRoleAll } from "../../Services/RoleService";

const UserPage = () => {
  const navigate = useNavigate();
  const mTable = useRef();
  const { userInfo } = useSelector((state) => state.auth);

  const [state, setState] = useState({
    options: [],
  });

  const onEdit = (item) => () => {
    navigate("edit/" + item._id);
  };

  const onResetPassword = (item) => () => {
    Swal.fire({
      icon: "question",
      title: "Are you sure",
      text: "Reseted password can not be restored",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        Swal.fire({
          title: "Input the new password here!",
          input: "password",
          showCancelButton: true,
          confirmButtonText: "Reset",
        }).then(({ value }) => {
          resetPassword(item._id, { password: value })
            .then((res) => {
              toastSuccess("Reset password success");
              mTable.current.refresh();
            })
            .catch(({ response: { err } }) => {
              toastError("Reset password failed");
            });
        });
      }
    });
  };

  const columns = [
    { id: uuid(), title: "NIK", field: "nik", sortable: true },
    { id: uuid(), title: "Full Name", field: "full_name", sortable: true },
    { id: uuid(), title: "User Name", field: "username", sortable: true },
    { id: uuid(), title: "Email", field: "email", sortable: true },
    {
      id: uuid(),
      title: "Role",
      field: "role_name",
      sortable: true,
      options: state.options,
    },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "Action",
      render: (item) => {
        return (
          <div>
            <EditButton title="Edit" onClick={onEdit(item)} />
            {(item.email || "").indexOf("@modena.com") == -1 && (
              <CustomButton
                title="Reset Password"
                type="danger"
                icon="fas fa-key"
                onClick={onResetPassword(item)}
              />
            )}
          </div>
        );
      },
    },
  ];

  const onAddData = () => {
    navigate("add/new");
  };

  const onActiveChange = (item) => (e) => {
    if (item._id == userInfo.userid) {
      toastError(`Can't change status of your account!`);
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteUser(item._id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  useEffect(() => {
    getRoleAll({ perpage: 1000 }, ({ data }) => {
      const _options = data.data.map((item) => {
        return {
          label: item.role_name,
          value: item.role_name,
        };
      });

      setState({ ...state, options: _options });
    });
  }, []);

  const propsTable = {
    defaultSort: "_id",
    columns,
    getData: getUserAll,
    showIndex: true,
    showAddButton: true,
    onAddData,
    enableFilter: true,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Manage User</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item active">User</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">
                    <i className="fa fa-user-tag" /> List User
                  </div>
                </div>
                <div className="card-body">
                  <MTable ref={mTable} {...propsTable} order="full_name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserPage;
